<template>
  <!--header-->
  <header id="header" class="header header-style-1">
    <jsonld></jsonld>
    <jsonldfaq></jsonldfaq>
    <div class="container-fluid">
      <div class="row">
        <div class="wrap-banner-top text-center" v-show="showTopBanner">
          <a :href="bannerLink"
            ><figure><img :src="bannerUrl" :alt="bannerAlt" :title="bannerTitle" width="1920" height="88" /></figure
          ></a>
        </div>

        <TopMenu></TopMenu>

        <div class="container">
          <div class="mid-section main-info-area">
            <div class="wrap-logo-top left-section">
              <a :href="`${$SiteUrl}/loja`" rel="nofollow" class="link-to-home"
                ><img style="min-width: 160px" src="/assets/images/logo-top-aldo-solar.png" alt="Logo Aldo" title="Logo Aldo"
              /></a>
            </div>

            <Search></Search>

            <AccountDetails
              :count="count"
              :cartRedirect="cartRedirect"
              :productList="productList"
              :totalKombi="totalKombi"
              :kombiList="kombiList"
            ></AccountDetails>
          </div>
        </div>

        <div class="nav-section header-sticky">
          <!--<MiddleMenu></MiddleMenu>-->

          <!-- Menu Principal de categorias -->
          <!-- <BottomMenu></BottomMenu> -->
          <MenuSegments></MenuSegments>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import TopMenu from './header-default/TopMenu.vue'
//import MiddleMenu from './header-default/MiddleMenu.vue'
// import BottomMenu from './header-default/BottomMenu.vue'
import MenuSegments from './header-default/MenuSegments.vue'
import Search from './header-default/Search.vue'
import AccountDetails from './header-default/AccountDetails.vue'
import axios from 'axios'
import jsonld from '../structured-data/json-ld-organization.vue'
import jsonldfaq from '../structured-data/json-ld-faq.vue'

export default {
  name: 'HeaderDefault',
  components: {
    TopMenu,
    //MiddleMenu,
    jsonld,
    jsonldfaq,
    Search,
    AccountDetails,
    MenuSegments,
  },
  props: ['count', 'productList', 'totalKombi', 'cartRedirect', 'kombiList'],
  data() {
    return {
      bannerUrl: '',
      bannerTitle: '',
      bannerAlt: '',
      bannerLink: '',
      showTopBanner: false,
    }
  },
  mounted() {
    var self = this
    let xhr = new XMLHttpRequest()
    xhr.open('GET', this.$apiUrl + 'Marketing.svc/listbannertopo')
    xhr.setRequestHeader('Content-type', 'application/json')
    xhr.withCredentials = false
    xhr.onload = () => {
      if (xhr.status == 200) {
        let bannersTop = JSON.parse(xhr.responseText)

        bannersTop.forEach((element, index) => {
          var tipo = element.Tipo.toLowerCase()
          var id = element.ID
          var banner = element.Banner
          self.bannerAlt = element.Alt
          self.bannerTitle = element.Title
          var url = element.Url
          if (url.startsWith('http')) {
            url = element.Url
          } else {
            if (element.Tipo === 'Campanha') url = `${this.$SiteUrl}/loja/campanhas/${url}`
            else url = `${this.$SiteUrl}/loja/marcas/${url}`
          }
          self.bannerUrl = self.$imageUrl + '/Content/img/' + tipo + '/' + id + '/aldo40/' + banner
          self.bannerLink = url
          self.showTopBanner = true
        })
      }
    }
    xhr.send()
  },
}
</script>
